const mappings = {
  mg: 'MG',
  mini: 'MINI',
  bmw: 'BMW',
  tvr: 'TVR',
  ktm: 'KTM',
  ds: 'DS',
  'mercedes-benz': 'Mercedes-Benz',
  'rolls-royce': 'Rolls Royce',
  'mg motor uk': 'MG Motor UK'
};

const hasNumber = str => /\d/.test(str);

export const hasHyphen = str => /-/.test(str);

const capitalizeWords = str =>
  str.replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

export const formatModelWords = str => {
  const words = str.split(' ');
  return words
    .map(w =>
      (w.length === 4 && hasNumber(w)) || hasHyphen(w) || w.length <= 3
        ? w.toUpperCase()
        : capitalizeWords(w)
    )
    .join(' ');
};

export const changeMake = make => {
  make = mappings[make] || capitalizeWords(make);
  return make;
};

export const changeModel = model => formatModelWords(model);



// WEBPACK FOOTER //
// ./src/Common/makeAndModelFormatting/index.js